module.exports = __webpack_public_path__ + "static/tangem-4c3e86da622642a5ce4a46cf06c9d19a.webp";